import { Stack, StackProps } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { FC } from 'react';

export const WarningBlock: FC<StackProps> = ({ children, sx, ...props }) => {
  return (
    <Stack
      sx={(theme) => ({
        border: `1px solid ${theme.palette.common.orange}`,
        borderRadius: theme.spacing(1),
        bgcolor: theme.palette.common.orange5,
        color: theme.palette.common.orange,
        p: 2,
        ...((typeof sx === 'function' ? sx(theme) : sx) as SystemStyleObject),
      })}
      {...props}
    >
      {children}
    </Stack>
  );
};
